import { watch } from 'vue'
import type { ChangelogItem, RightyMessage } from '../types'
import { assistantMessageAppliedConfigMutation } from '../services/configMutationDetection'

type RightyMutationSyncStore = {
  isStreaming: boolean
  messages: RightyMessage[]
  setMessageChangelog: (messageId: number, changelog: ChangelogItem[]) => void
}

export function useRightyConfigMutationSync(args: {
  rightyStore: RightyMutationSyncStore
  refetchConfig: () => void
}) {
  return watch(
    () => args.rightyStore.isStreaming,
    (isStreaming, wasStreaming) => {
      if (!wasStreaming || isStreaming) return

      const lastMessage = args.rightyStore.messages[args.rightyStore.messages.length - 1]
      if (lastMessage?.role !== 'assistant') return

      const backendChangelog = lastMessage.metadata?.planApplied?.changelog
      if (backendChangelog && backendChangelog.length > 0) {
        args.rightyStore.setMessageChangelog(lastMessage.id, backendChangelog as ChangelogItem[])
      }

      if (assistantMessageAppliedConfigMutation(lastMessage)) {
        args.refetchConfig()
      }
    }
  )
}
